import Router from "next/router";
import { useEffect, useRef, useState } from "react";

export const usePageLoading = () => {
	const [isPageLoading, setIsPageLoading] = useState(false);
	const timerRef = useRef(null);

	useEffect(() => {
		// Delay the page loading state by 750ms. This prevents the loading page from popping up too quickly, which is annoying when a page does load quickly.
		const delay = 750;

		const routeEventStart = () => {
			// Clear any existing timer first
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
			// Set a new timer based on the delay constant
			timerRef.current = setTimeout(() => {
				setIsPageLoading(true);
			}, delay);
		};

		const routeEventEnd = () => {
			// Clear the existing timer
			if (timerRef.current) {
				clearTimeout(timerRef.current);
				timerRef.current = null;
			}
			setIsPageLoading(false);
		};
		// Turn on event listeners for route change states
		Router.events.on("routeChangeStart", routeEventStart);
		Router.events.on("routeChangeComplete", routeEventEnd);
		Router.events.on("routeChangeError", routeEventEnd);

		return () => {
			// Turn off event listeners for route change states as they are no longer needed
			Router.events.off("routeChangeStart", routeEventStart);
			Router.events.off("routeChangeComplete", routeEventEnd);
			Router.events.off("routeChangeError", routeEventEnd);
		};
	}, []);

	return { is_page_loading: isPageLoading };
};
